<template>
  <div>
	<div class="w100 shiyong-box">
      <div class="lingqu-text">立即联系我们，提供演示版本</div>
			<div class="tel-num">
				<img src="@/assets/img/tel-icon1.png" class="tel-img" alt="" srcset="">
				029-89531063
			</div>
			<!-- <div class="input-box">
				<input type="text" placeholder="请填写您的手机号" maxlength="130" class="input-element">
				<div class="lingqu-btn">立即领取</div>
			</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'shiyong',

  data() {
	return {
	  
	};
  },

  mounted() {
	
  },

  methods: {
	
  },
};
</script>
<style lang="scss" scoped>
	
.shiyong-box{
	max-height: 252px;
	padding-bottom: 78px;
	padding-top: 68px;
  background-image: url("../assets/img/shiyong-bg.png");
  background-position: left center;
  background-size: 100% 100%;
	box-sizing: border-box;
  .lingqu-text{
    text-align: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 26px;
    color: #FFFFFF;
  }
	.tel-num{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: auto;
		margin-right: auto;
		margin-top: 20px;
		padding: 10px 15px;
		width: 230px;
		border:1px solid #ffffff;
		border-radius: 200px;
		text-align: center;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		font-size: 18px;
		font-weight: 700;
		color: #FFFFFF;
		box-sizing: border-box;
		.tel-img{
			width: 30px;
			height: 30px;
			margin-right: 10px;
			vertical-align: middle;
		}
	}
  .input-box{
    display: flex;
    justify-content: center;
    width: 44rem;
    max-width: 44rem;
    margin: auto;
    margin-top: 2.7rem;
    border-radius: 4px;
    background-color: #ffffff;
    box-sizing: border-box;
    .input-element{
      width: calc(100% - 113px);
      height: 44px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      padding-left: 1.4rem;
      padding-right: 1.4rem;
      outline: none;
    }
    .lingqu-btn{
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 113px;
      height: 44px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      background: #2E7AF0;
      border-radius: 4px;
      border: 1px solid #FFFFFF;
    }
  }
}
</style>